import React, { useState, useEffect } from 'react';
import { ListColumn } from '../../common/list-entities/ListColumn';
import EntityList from '../../common/EntityList';
import { OPERATORS, TYPES, prepareAppSelector } from '../../common/utility-list';
import PathManagement from '../../common/path-management';
import NotificationsModal from './notifications-modal.js';
import Modal from 'react-modal';
import NotificationsView from '../../classes/notifications';
// import { useNavigate } from 'react-router-dom';

interface Notification {
  bms_asunto: string;
  bms_autor: string;
  bms_carpeta: string;
  bms_clave_seguim: string;
  bms_descripcion: string;
  bms_estado: string;
  bms_fecha_hora: string;
  bms_id: string;
  bms_leido: string;
  bms_orden: string;
  bms_pedido_id: string;
  bms_sector: string;
  bms_sistema: string;
  bms_usuario_from: string;
  bms_usuario_to: string;
  pedido: null;
  usuario: null;
}

const NotificationList = (props) => {
  // const navigate = useNavigate();
  const [ModalIsOpen, setModalIsOpen] = useState(false);
  const [SelectedMessageId, setSelectedMessageId] = useState(null);
  const [NotificationList, setNotificationList] = useState(null);
  const [refreshList, setRefreshList] = useState(true);

  useEffect(() => {
    props.onContentLoaded();
  }, [])

  useEffect(() => {
    if (!ModalIsOpen) {
      changeRefreshList();
    }
  }, [ModalIsOpen]);

  function closeModal() {
    setModalIsOpen(false);
  }

  function openModal() {
    //   alert('a')
    setModalIsOpen(true);
    // setSelectedMessageId(e.currentTarget.id);
  }

  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      border: 'none',
      backgroundColor: 'none',
      background: 'none',
      zId: '1200',
    },
  };

  const readNotification = async (id) => {
    let _notifications = new NotificationsView();
    let _res = await _notifications.read1Notification(id);
    if (_res) {
      //   console.log(_res)
      // props.getNotifications();
    }
  };

  const readAllNotifications = async () => {
    let _notifications = new NotificationsView();
    let _res = await _notifications.readAllNotifications();
    if (_res) {
      // props.getNotifications();
    }
  };

  const formatLeido = (row: Notification) => {
    return row.bms_leido == '0' ? (
      <i className={'icon-mail blue'} style={{ fontSize: '20px' }}></i>
    ) : (
      <i className={'icon-mail'} style={{ fontSize: '20px' }}></i>
    );
  };

  const changeRefreshList = () => {
    if (NotificationList && NotificationList.bms_leido === '0') {
      setRefreshList(!refreshList);
    }
  };

  const [columns] = useState<ListColumn<Notification>[]>([
    new ListColumn<Notification>(
      'bms_leido',
      'No Leido',
      1,
      true,
      TYPES.CHECKBOX,
      OPERATORS.EQUAL,
      true
    ).setFormat(formatLeido),
    new ListColumn<Notification>('bms_asunto', 'Filtrar por asunto', 3, true),
    new ListColumn<Notification>('bms_fecha_hora', 'Fecha', 4),
    new ListColumn<Notification>('bms_clave_seguim', 'Clave', 3),
    new ListColumn<Notification>('bms_autor', 'Filtrar por remitente', 4, true),
  ]);

  const _pathMngr = new PathManagement();
  const baseUrl = _pathMngr.getAllNotificationsList();

  //Me quede acá. Tengo que pasar el refresh list a cuando cerras el modal para probar si asi se actualiza bien la lectura
  const handleClick = (row: Notification) => {
    readNotification(row.bms_id);
    // if(row.bms_leido==='0'){changeRefreshList()}
    setNotificationList(row);
    openModal();
    setSelectedMessageId(row.bms_id);
  };

  return (
    <div>
      <div className="page-title">
        <div className="container">
          <div className="column">
            <h1 id="item-category">
              {' '}
              <i className="icon-bell info-custom-icon mr-2"></i>Notificaciones
            </h1>
          </div>

          {/* <Breadcrumbs breadcrumbs={BreadcrumbPath} /> */}
        </div>
      </div>

      <div className="container padding-bottom-3x mb-1">
        {/* <div className='col-sm-12' style={{paddingRight: '0px'}}> */}
        <div className={props.NotificationsMsg && props.NotificationsMsg[0] ? '' : 'hidden'}>
          <button
            onClick={() => {
              readAllNotifications();
              setRefreshList(!refreshList);
            }}
            className="btn-labeled  btn btn-info btn-sm mb-3"
            style={{ marginLeft: '-0.3rem' }}
          >
            Marcar todas como leídas
          </button>
        </div>
        {/* </div> */}
        <EntityList baseUrl={baseUrl} columns={columns} onClickRow={handleClick} refresh={refreshList} />{' '}
      </div>
      <Modal
        isOpen={ModalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Example Modal"
        style={customStyles}
      >
        <NotificationsModal
          closeModal={closeModal}
          NotificationsMsg={NotificationList}
          SelectedMsgId={SelectedMessageId}
          // changeRefreshList={changeRefreshList}
        />
      </Modal>
    </div>
  );
};

export default NotificationList;
